var site = site || {};

site.direction = site.direction || {};

(function ($) {
  Drupal.behaviors.productTabbedSliderContentBlockV1 = {
    attach: function (context) {
      var $template = $('.js-product-tabbed-slider--v1', context);
      var $carousel = $('.js-product-tabbed-slider-carousel', $template);
      var $triggers = $('.js-product-tabbed-slider-trigger', $template);
      var $blocks = $('.js-product-tabbed-slider-block', $template);
      var activeIndex = $triggers.filter('.active').length ? $triggers.filter('.active').index() : 1;
      var settings = {
        rtl: site.direction.isRTL,
        arrows: true,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        focusOnSelect: false,
        draggable: false,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              arrows: true,
              dots: false,
              draggable: true,
              slidesToShow: 3
            }
          },
          {
            breakpoint: 768,
            settings: {
              arrows: true,
              dots: false,
              draggable: true,
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '12%'
            }
          }
        ]
      };

      $carousel.not('.slick-initialized').slick(settings);

      var $triggersWrapper = $triggers.parent();
      var isMobile = Unison.fetch.now().name === 'small';
      if (isMobile) {
        if (!$triggersWrapper.hasClass('slick-initialized')) {
          $triggersWrapper.slick({
            rtl: site.direction.isRTL,
            arrows: false,
            dots: false,
            draggable: false,
            slidesToShow: 1.75,
            variableWidth: true,
            slidesToScroll: 1,
            infinite: false
          });
          $triggersWrapper.on('afterChange.productTabbedSlider', function (event, slick, currentSlide) {
            $triggers.filter('.active').removeClass('active');
            activeIndex = currentSlide;
            activateBlock();
          });
        }
      }

      $template.find('.js-product-tabbed-slider-item__images').each(function () {
        var $desktopImages = $(this).find('.js-product-tabbed-slider-mobile-hidden');
        if ($desktopImages.length === 1) {
          $(this).addClass('product-tabbed-slider-item__images--single');
        }
      });
      if (!$triggers.length) {
        $blocks.removeClass('hidden');
        return false;
      }
      function activateBlock() {
        $triggers.eq(activeIndex).addClass('active');
        $blocks.hide();
        var $activeBlock = $blocks.eq(activeIndex);
        $activeBlock.fadeIn(300, function () {
          var $slickElement = $activeBlock.find('.slick-initialized');
          $slickElement.each(function () {
            this.slick?.setPosition();
          });
        });
      }

      $triggers.on('click.activeTab', function (event) {
        event.preventDefault();
        $triggers.filter('.active').removeClass('active');
        activeIndex = $(this).index();
        activateBlock();
      });

      $blocks.hide().removeClass('hidden');
      activateBlock();
    }
  };
})(jQuery);
